import { Action, ActionType, PageType, State } from "../types";

export const handleLandingPage = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.ALL_DATA_LOADED: {
      return {
        ...state,
        page: PageType.NEW_CREDIT_LIMIT,
        accountInfo: action.accountInfo,
        userAddress: action.userAddress,
        userMobilePhoneNumber: action.userMobilePhoneNumber,
        userHomePhoneNumber: action.userHomePhoneNumber,
        userWorkPhoneNumber: action.userWorkPhoneNumber,
        submitUrl: action.submitUrl,
        acknowledgementUrl: action.acknowledgementUrl,
      };
    }

    case ActionType.ACCOUNT_INFO_LOADED_NZ: {
      return {
        ...state,
        page: PageType.NZ_FORM,
        accountInfo: action.accountInfo,
      };
    }

    case ActionType.OTP_REQUIRED: {
      return {
        ...state,
        page: PageType.OTP,
        accountInfo: action.accountInfo,
        maskedMobileNumber: action.maskedMobileNumber,
        otpVerifyUrl: action.otpVerifyUrl,
        otpResendUrl: action.otpResendUrl,
      };
    }

    case ActionType.GET_APPLICATION_FAILED:
    case ActionType.GET_PERSONAL_DETAILS_FAILED:
    case ActionType.OTP_SESSION_CREATION_FAILED: {
      return {
        ...state,
        page: PageType.ERROR,
        accountInfo: action.accountInfo,
      };
    }

    case ActionType.CLI_PENDING_CUST_CALL:
    case ActionType.CLI_PENDING_ASSESSMENT: {
      return {
        ...state,
        page: PageType.ASSESSED,
        accountInfo: action.accountInfo,
      };
    }

    case ActionType.CLI_PENDING_POI: {
      return {
        ...state,
        page: PageType.PROOF_OF_INCOME,
        accountInfo: action.accountInfo,
        bankConnectUrl: action.bankConnectUrl,
        expiryDate: action.expiryDate,
        latitudePoiUrl: action.latitudePoiUrl,
        cancelUrl: action.cancelUrl,
        employmentDetails: {
          ...state.employmentDetails,
          employmentStatus: action.employmentStatus,
        },
      };
    }

    case ActionType.CLI_PENDING_ACCEPTANCE: {
      return {
        ...state,
        page: PageType.CONFIRM_MMP,
        accountInfo: action.accountInfo,
      };
    }

    case ActionType.CLI_STA_PENDING_ACCEPTANCE: {
      return {
        ...state,
        page: PageType.CONFIRM_MMP,
        accountInfo: action.accountInfo,
        requestedCreditLimit: action.requestedCreditLimit / 100,
        newCreditLimit: String(action.approvedCreditLimit / 100),
        isConditionallyApproved: action.isConditionallyApproved,
        cancelUrl: action.cancelUrl,
        acknowledgementUrl: action.acknowledgementUrl,
      };
    }

    case ActionType.CLI_NOT_ELIGIBLE: {
      return {
        ...state,
        page: PageType.UNABLE_TO_INCREASE,
        accountInfo: action.accountInfo,
      };
    }

    case ActionType.CLI_FINAL_CANCEL: {
      return {
        ...state,
        page: PageType.FINAL_CANCEL,
        accountInfo: action.accountInfo,
      };
    }

    default: {
      return state;
    }
  }
};
